module.exports = __webpack_public_path__ + "static/img/wheelBgOutside.8ffb550.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/wheelBgOutside.webp
// module id = 9NRv
// module chunks = 0